import axios from "axios";
import Config from "../config/index";
/*import { notify } from "@kyvg/vue3-notification";*/
import router from '../router';

let eventSource;

class AuthService {
    async loginNew(user) {
        const response = await axios.post(
            Config.apiBasePath + "/auth/login",
            {
                userId: user.userId,
                password: user.password,
            }
        );
        return response.data;
    }

    async ssoLoginNew(callbackParams) {
        const response = await axios
            .post(Config.apiBasePath + "/auth/sso-login/callback", callbackParams);
        return response.data;
    }

    async login(user) {
        return axios
            .post(Config.apiBasePath + "/auth/login", {
                userId: user.userId,
                password: user.password,
            })
            .then((response) => {
                //console.log("Data",response);
                // if (response.data.token) {
                if (response.data.status) {
                    sessionStorage.setItem("user", JSON.stringify(response.data));
                    localStorage.setItem("user", JSON.stringify(response.data));
                    sessionStorage.removeItem("firstLogin");
                    sessionStorage.removeItem("firstLoginMessage");
                } else {
                    if (response.data.status_code == 111) {
                        sessionStorage.setItem(
                            "firstLogin",
                            JSON.stringify(response.data.user_id)
                        );
                        sessionStorage.setItem("firstLoginMessage", response.data.message);
                    } else {
                        sessionStorage.removeItem("firstLogin");
                        sessionStorage.removeItem("firstLoginMessage");
                    }
                }

                return response.data;
            })
            .catch(error => {
                console.log("error", error.response.data.message);
                /*notify({
                    type: "error",
                    title: "Authorization",
                    text: error.response.data.message,
                });*/
            })
            .finally(() => {

            });
    }

    async logout() {
        const user = JSON.parse(localStorage.getItem('user'));
        localStorage.clear();

        if (user.data.sid === null || user.data.sid === '') {
            const res = await axios.post(Config.apiBasePath + "/logout", {}, {headers: {Authorization: "Bearer " + user.token.token}});
            router.push("/");
            return res;
        } else {
            const url = await axios.post(Config.apiBasePath + "/sso-logout?id_token=" + user.data.id_token, {}, {headers: {Authorization: "Bearer " + user.token.token}});
            window.location.href = url.data;
        }
    }

    async ssoLogout(id_token, b_token) {
        const url = await axios.post(Config.apiBasePath + "/sso-logout?id_token=" + id_token, {}, {headers: {Authorization: "Bearer " + b_token}});
        console.log("url", url.data)
        window.location.href = url.data;
    }

    async firstLogin(form) {
        return await axios.post(Config.apiBasePath + "/user/first-login", form);
    }

    ssoLogin(callbackParams) {
        return axios
            .post(Config.apiBasePath + "/auth/sso-login/callback", callbackParams)
            .then((response) => {
                // if (response.data.token) {
                if (response.data.status) {
                    sessionStorage.setItem("user", JSON.stringify(response.data));
                    localStorage.setItem("user", JSON.stringify(response.data));
                    sessionStorage.removeItem("firstLogin");
                    sessionStorage.removeItem("firstLoginMessage");
                    this.initiateBackChannelLogoutEvent();
                } else {
                    if (response.data.status_code == 111) {
                        sessionStorage.setItem(
                            "firstLogin",
                            JSON.stringify(response.data.user_id)
                        );
                        sessionStorage.setItem("firstLoginMessage", response.data.message);
                    } else {
                        sessionStorage.removeItem("firstLogin");
                        sessionStorage.removeItem("firstLoginMessage");
                    }
                }

                return response.data;
            });
    }

    initiateBackChannelLogoutEvent() {
        eventSource = new EventSource(Config.apiBasePath + '/auth/sse');

        /*eventSource.onpen = (e) => {
            console.log('Connected ', e);
        }*/

        eventSource.addEventListener('logoutEvent', (event) => {
            const user = JSON.parse(localStorage.getItem('user'));
            const sseData = JSON.parse(event.data);
            if (user !== null && sseData != null) {
                /*console.log('user ', user);
                console.log('sseData ', sseData);*/
                if (user.data.sid === sseData.sid) {
                    this.logout();
                }
            }
            // eventSource.close();
        });

        /*eventSource.onerror = () => {
            eventSource.close();
        };*/
    }

    async sendForOTP(param) {
        const response = await axios.get(
            Config.apiBasePath + "/auth/generateLoginOtp",
            {params: param}
        );
        return response.data;
    }

    async validateLoginOTP(param) {
        const response = await axios.get(
            Config.apiBasePath + "/auth/validateLoginOtp",
            {params: param}
        );
        return response.data;
    }

    async getResetOtp(param) {
        const response = await axios.get(
            Config.apiBasePath + "/auth/getResetOtp",
            {params: param}
        );
        return response.data;
    }

    async validateOtp(param) {
        const response = await axios.get(
            Config.apiBasePath + "/auth/validateResetOtp",
            {params: param}
        );
        return response.data;
    }

    async resetPassword(param) {
        const response = await axios.post(
            Config.apiBasePath + "/auth/reset-password", null,
            {params: param}
        );
        return response.data;
    }
}

export default new AuthService();
